<template>
    <u-combobox-outlined-rounded>
        <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
            <slot :name="slotName" />
        </template>
    </u-combobox-outlined-rounded>
</template>

<script>
import UComboboxOutlinedRounded from "@/components/publish/styles/forms/u-combobox-outlined-rounded.vue";

export default {
    props: {},
    components: {
        UComboboxOutlinedRounded,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
